export const companyProfile = {
  brandName: 'Vedanskrix College Admission',
  legalName: 'Vedanskrix Web LLP',
  tagline: 'Guiding students from shortlist to visa approval.',
  foundedYear: '2023',
  location: 'Vastral, Ahmedabad, Gujarat',
  phone: '+91 8758637022',
  whatsapp: '+91 8758637022',
  primaryEmail: 'vedanskrix@gmail.com',
  secondaryEmail: 'info@vedanskrix.com',
  websiteUrl: 'https://eduadmit.vedanskrix.com',
  registeredAddress:
    'E-106 Akshardham Heights, Opp. Mahesul Bhavan, S.P. Ring Road, Vastral Road, Ahmedabad, Gujarat 382418, India',
};

export const navigationLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'Countries', to: '/countries' },
  { label: 'Process', to: '/process' },
  { label: 'Contact', to: '/contact' },
];

export const heroSlides = [
  {
    image: '/admission-guidance.png',
    eyebrow: 'College Admission Experts',
    title: 'Your path to the right college starts with the right guidance.',
    description:
      'Vedanskrix helps students choose strong-fit courses, colleges, and application plans with clear one-to-one support.',
    primaryCta: { label: 'Book Counselling', to: '/contact' },
    secondaryCta: { label: 'Explore Services', to: '/services' },
  },
  {
    image: '/silder1.jfif',
    eyebrow: 'Application Strategy',
    title: 'Shortlist smarter and apply with stronger documentation.',
    description:
      'We support profile review, application planning, SOP guidance, and every key document needed for confident submissions.',
    primaryCta: { label: 'View Process', to: '/process' },
    secondaryCta: { label: 'Study Destinations', to: '/countries' },
  },
  {
    image: '/slider2.jfif',
    eyebrow: 'Visa Support',
    title: 'Prepare for interviews, visa filing, and pre-departure with less stress.',
    description:
      'From document checks to travel readiness, we help students stay organised and better prepared for each next step.',
    primaryCta: { label: 'Talk To Us', to: '/contact' },
    secondaryCta: { label: 'Admission Services', to: '/services' },
  },
];

export const highlights = [
  { value: '150+', label: 'Student guidance sessions completed' },
  { value: '05', label: 'Priority study destinations' },
  { value: '1:1', label: 'Personal counselling support' },
  { value: 'End-to-End', label: 'Application to visa assistance' },
];

export const aboutSection = {
  title: 'Admission support built around clarity, fit, and confidence.',
  body: [
    'Vedanskrix College Admission helps students and families make better higher-education decisions with practical counselling and structured admission support.',
    'We guide students through profile evaluation, course selection, university shortlisting, application filing, documentation review, visa preparation, and pre-departure readiness.',
  ],
};

export const serviceCards = [
  {
    title: 'Profile Evaluation',
    summary: 'Understand your academic profile, course fit, strengths, and realistic admission pathway.',
  },
  {
    title: 'College Shortlisting',
    summary: 'Build a balanced target list based on budget, eligibility, ranking, and long-term career goals.',
  },
  {
    title: 'Application Support',
    summary: 'Get help with application forms, document sequencing, submission timelines, and requirement checks.',
  },
  {
    title: 'SOP And LOR Guidance',
    summary: 'Strengthen statements and recommendation support with clearer positioning of your profile.',
  },
  {
    title: 'Visa Preparation',
    summary: 'Receive visa file review, interview support, and checklist guidance before submission.',
  },
  {
    title: 'Pre-Departure Help',
    summary: 'Stay ready for accommodation, travel planning, university reporting, and arrival basics.',
  },
];

export const countryCards = [
  {
    code: 'UK',
    name: 'United Kingdom',
    focus: 'Undergraduate, postgraduate, and one-year masters options with globally recognised institutions.',
  },
  {
    code: 'USA',
    name: 'United States',
    focus: 'Wide program choices, research-driven universities, and flexible academic pathways.',
  },
  {
    code: 'CA',
    name: 'Canada',
    focus: 'Popular for quality education, practical learning, and clear student-friendly admission routes.',
  },
  {
    code: 'AUS',
    name: 'Australia',
    focus: 'Career-focused programs, strong campus life, and highly preferred destination options.',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    focus: 'English-taught programs, innovation-led education, and strong European exposure.',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Initial Counselling',
    detail: 'We understand academic history, preferred stream, budget range, destination interest, and target intake.',
  },
  {
    step: '02',
    title: 'Course And College Planning',
    detail: 'We shortlist suitable institutions and structure a practical application roadmap with deadlines.',
  },
  {
    step: '03',
    title: 'Documentation And Applications',
    detail: 'We review documents, guide statements, and support accurate application submissions.',
  },
  {
    step: '04',
    title: 'Offer, Visa, And Departure',
    detail: 'We help with next-step planning after offers, visa file preparation, and pre-departure readiness.',
  },
];

export const testimonials = [
  {
    name: 'Riya Patel',
    destination: 'Canada Admission Support',
    quote:
      'The shortlisting and document guidance made my entire admission process much more organised and less stressful.',
  },
  {
    name: 'Harsh Shah',
    destination: 'UK Student Guidance',
    quote:
      'I was confused about university options, but the team explained course fit and timelines in a very simple way.',
  },
  {
    name: 'Khushi Desai',
    destination: 'Australia Visa Preparation',
    quote:
      'Their interview and visa checklist support helped me feel much more confident before submission.',
  },
];

export const faqs = [
  {
    question: 'Do you help with course and college selection?',
    answer: 'Yes. We guide students on course fit, destination planning, budget-based options, and realistic college shortlisting.',
  },
  {
    question: 'Can you review SOP, LOR, and documents?',
    answer: 'Yes. We help review and organise key admission documents before applications or visa filing.',
  },
  {
    question: 'Do you support visa preparation too?',
    answer: 'Yes. We support document checks, filing readiness, and interview preparation guidance.',
  },
];

export const contactServices = [
  'Profile Evaluation',
  'College Shortlisting',
  'Application Support',
  'SOP / LOR Guidance',
  'Visa Support',
  'Pre-Departure Support',
  'Other / Not Sure',
];
